export function sortWeeklyItems(sortBy) {
    const container = document.getElementById('items');
    if (!container) return;

    const items = Array.from(container.querySelectorAll('.item'));

    items.sort((a, b) => {
        switch (sortBy) {
            case 'alpha': {
                const titleA = a.querySelector('.weekly__headline').textContent.trim();
                const titleB = b.querySelector('.weekly__headline').textContent.trim();
                return titleA.localeCompare(titleB, 'de');
            }
            case 'popular':
                return parseInt(b.dataset.popular, 10) - parseInt(a.dataset.popular, 10);             case 'date':
            default:
                return new Date(b.dataset.date) - new Date(a.dataset.date);
        }
    });

    items.forEach(item => container.appendChild(item));
}

export function initSortSelectWeekly() {
    const select = document.getElementById('sort-select');
    if (!select) return;

    select.addEventListener('change', e => sortWeeklyItems(e.target.value));

    // initial nach aktuellem Select-Wert sortieren
    sortWeeklyItems(select.value);
}

export function sortItemsByUrl() {
    const container = document.querySelector('.swiper-wrapper');
    if (!container) return;

    const params = new URLSearchParams(window.location.search);
    const sortingParam = params.get('sorting');
    if (!sortingParam) return;

    // Erlaubt Buchstaben, Zahlen, Bindestriche und Unterstriche, kommagetrennt
    if (!/^[\w-]+(,[\w-]+)*$/.test(sortingParam)) {
        console.warn('sortItemsByUrl: ungültiges Format, Sortierung ignoriert');
        return;
    }

    const order = sortingParam.split(',');

    const items = Array.from(container.querySelectorAll('.swiper-slide'));
    const domIds = items.map(item => item.dataset.id);

    if (new Set(order).size !== order.length) {
        console.warn('sortItemsByUrl: doppelte IDs im Parameter, Sortierung ignoriert');
        return;
    }

    if (order.length !== domIds.length) {
        console.warn(
            `sortItemsByUrl: Anzahl stimmt nicht überein (Parameter: ${order.length}, Slides: ${domIds.length}), Sortierung ignoriert`
        );
        return;
    }

    const allIdsExist = order.every(id => domIds.includes(id));
    if (!allIdsExist) {
        console.warn('sortItemsByUrl: Parameter enthält unbekannte IDs, Sortierung ignoriert');
        return;
    }

    items.sort((a, b) => {
        return order.indexOf(a.dataset.id) - order.indexOf(b.dataset.id);
    });

    items.forEach((item, index) => {
        container.appendChild(item);

        // Nummerierungs-Div hinzufügen (1-basiert)
        const badge = document.createElement('div');
        badge.className = 'weekly__sorting';
        badge.textContent = index + 1;
        item.querySelector('.weekly__details')?.prepend(badge);
    });

    document.querySelector('.collection')?.classList.add('is-sorted');
}